export default __webpack_public_path__ + "static/media/shoe.7884b666.png";